module.exports = __webpack_public_path__ + "img/fruit-tangerines-190x100.40fc7808.jpg";